// Build-time configuration, sourced from .env / .env.local (see .env.example).

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing ${name} — add it to .env (see .env.example)`);
  }
  return value;
}

/** Backend API root, guaranteed without a trailing slash. */
export const API_BASE = required(
  'VITE_API_BASE',
  import.meta.env.VITE_API_BASE
).replace(/\/+$/, '');
